<section class="learning-library">
  <div class="container">
    <ng-container
      *ngIf="
        !selectedLessonId &&
        !showQuizPage &&
        !showQuizQuestions &&
        !showQuizCompletion
      "
    >
      <div class="learning-library-header">
        <h1 class="c11n-space-stack-2x">
          {{ 'learningLibrary.header' | translate }}
        </h1>
        <div class="c11n-text-md c11n-space-stack-2x">
          {{ 'learningLibrary.description' | translate }}
        </div>
        <!-- <div class="filter-section">
          <div class="search-bar-wrapper">
            <c11n-search
              #searchComponent
              [id]="'uniqueId'"
              [hasMenu]="false"
              [hideLabel]="true"
              [labelText]="'learningLibrary.searchLabel' | translate"
              [hideSearchButton]="true"
              [placeHolderText]="
                'learningLibrary.searchPlaceholder' | translate
              "
              (stateChange)="onSearchChange($event)"
            >
            </c11n-search>
          </div>
          <p class="visually-hidden" aria-live="polite" aria-atomic="true">
            {{ searchResultText }}
          </p>

          <div class="sort-difficulty-wrapper">
            <div class="difficulty-section">
              <span class="difficulty-label" aria-hidden="true">{{
                'learningLibrary.difficultyLabel' | translate
              }}</span>
              <ng-container *ngFor="let level of difficultyLevels">
                <c11n-button
                  [ariaLabelText]="
                    ('learningLibrary.lessonCard.difficulty_level'
                      | translate) +
                    ' ' +
                    level.toString() +
                    (isDifficultySelected(level)
                      ? ', selected'
                      : ', not selected')
                  "
                  [labelText]="level.toString()"
                  [size]="'small'"
                  [variant]="
                    isDifficultySelected(level) ? 'primary' : 'secondary'
                  "
                  (clickEvent)="setDifficulty(level)"
                >
                </c11n-button>
              </ng-container>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Empty state when no lessons available -->
      <div
        *ngIf="dataLoaded && filteredLessons.length === 0"
        class="empty-state"
      >
        <div class="empty-state-content">
          <h2>{{ 'learningLibrary.noLessons' | translate }}</h2>
        </div>
      </div>

      <div
        *ngIf="!dataLoaded && filteredLessons.length === 0"
        class="empty-state"
      >
        <div class="empty-state-content">
          <c11n-spinner
            [size]="'large'"
            [spinnerStatus]="'Loading...'"
          ></c11n-spinner>
        </div>
      </div>

      <div class="learning-library-content" *ngIf="filteredLessons.length > 0">
        <div class="sdl-difficulty-cards">
          <div *ngFor="let quiz of filteredLessons; let i = index">
            <app-lesson-card
              [index]="i"
              [quizId]="quiz.id"
              [userRole]="'student'"
              [cardType]="'assignment'"
              [quizTitle]="quiz.learningTitle"
              [learnDescription]="getLearnDescription(quiz)"
              [difficultyLevel]="getDifficultyLevel(quiz.level)"
              [imageUrl]="getImageUrl(quiz)"
              (viewLesson)="onViewLesson(quiz)"
            >
            </app-lesson-card>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Show lesson content using the shared LearningContentComponent -->
    <app-learning-content
      *ngIf="
        showLessonContent &&
        selectedLessonId &&
        !showQuizPage &&
        !showQuizQuestions &&
        !showQuizCompletion
      "
      [lessonId]="selectedLessonId"
      [lessonPath]="selectedLessonPath"
      [userRole]="'student'"
      (backToLibrary)="onBackToLibrary()"
      (goToQuiz)="onGoToQuiz($event)"
    >
    </app-learning-content>

    <app-learning-quiz
      *ngIf="
        showQuizPage &&
        selectedLessonId &&
        !showQuizQuestions &&
        !showQuizCompletion
      "
      [lessonId]="selectedLessonId"
      [lessonTitle]="selectedLessonTitle"
      [quizData]="currentQuizData"
      (backToLesson)="onBackToLesson()"
      (startQuizEvent)="onStartQuiz($event)"
      (backToLibrary)="onBackToLibrary()"
    >
    </app-learning-quiz>

    <app-learning-quiz-questions
      *ngIf="selectedLessonId && showQuizQuestions && !showQuizCompletion"
      [lessonId]="selectedLessonId"
      [lessonTitle]="selectedLessonTitle"
      [quizPath]="currentQuizData?._path"
      [quizQuestions]="currentQuizQuestions"
      [quizData]="currentQuizData"
      [lessonPath]="selectedLessonPath"
      [quizFormValue]="quizFormValue"
      (backToQuizIntro)="onBackToQuizIntro()"
      (backToLibrary)="onBackToLibrary()"
      (submitQuiz)="onSubmitQuiz($event)"
    >
    </app-learning-quiz-questions>

    <app-learning-quiz-completion
      *ngIf="showQuizCompletion && selectedLessonId"
      [score]="quizScore"
      [totalQuestions]="totalQuizQuestions"
      [lessonTitle]="selectedLessonTitle || ''"
      [quizTitle]="selectedLessonTitle || ''"
      (retakeQuiz)="onRetakeQuiz()"
      (revisitLesson)="onRevisitLesson()"
      (backToLibrary)="onBackToLibrary()"
      (nextLesson)="onNextLesson()"
    >
    </app-learning-quiz-completion>
  </div>
</section>

<section
  *ngIf="
    !selectedLessonId &&
    !showQuizPage &&
    !showQuizQuestions &&
    !showQuizCompletion
  "
  class="contact-us-footer text-center c11n-space-inset-6x"
>
  <div class="c11n-space-stack-3x">
    <div class="contact-us-footer-header c11n-space-stack-3x">
      {{ 'learningLibrary.contactUsFooter.header' | translate }}
    </div>
    <div class="c11n-text-md contact-us-footer-body">
      {{ 'learningLibrary.contactUsFooter.body' | translate }}
    </div>
  </div>
  <c11n-button
    [ariaLabelText]="'footer.contact_us_attr_current_tab' | translate"
    [routerLink]="'/aboutus' | langLink"
    [queryParams]="{ contact: 'true' }"
    [colorMode]="'on-dark'"
    [labelText]="'contactUs.title' | translate"
  ></c11n-button>
</section>
